import LogoWhite from "../assets/LogoWhite.svg"
import HomeIcon from "../components/Svg/HomeIcon"
import TransactionIcon from "../components/Svg/TransactionIcon"
import SettingsIcon from "../components/Svg/SettingsIcon"
import LogoutIcon from "../components/Svg/LogoutIcon"
import { NavLink } from "react-router-dom"
import CloseIcon from "./Svg/CloseIcon"

import { useState } from "react"
import LogoutModal from "./LogoutModal"

function Sidebar(props) {
 
  const [logOutModal, setLogOutModal] = useState(false);

 
  

  return (
   <div className={props.className}>
    <div className="side-top">
   <div className="st-head">
   <img className="side-logo"src={LogoWhite} alt="logo" />
   <div className="close-icon-group" onClick={props.onClick}>
     <CloseIcon fill='white'/>
   </div>
   </div>
     <div className="side-links">
        <NavLink className="side-link" to='user-dashboard' onClick={props.onClick}>
            <div className="side-icon-group">
           <HomeIcon className="home-icon side-icon" fill="#fff"/>
            </div>
              Dashboard
        </NavLink>
        <NavLink className="side-link" to="recent-transactions" onClick={props.onClick}>
           <div className="side-icon-group">
           <TransactionIcon className="transaction-icon side-icon" fill="#fff"/>
           </div>
            Transactions
        </NavLink>
        <NavLink className="side-link" to="settings" onClick={props.onClick}>
           <div className="side-icon-group">
           <SettingsIcon className="settings-icon side-icon" fill="#fff" />
           </div>
            Settings
        </NavLink>
     </div>
    </div>
     <div className="logout">
         <div className="side-link" onClick={() => setLogOutModal(true)}>
            <div className="side-icon-group">
            <LogoutIcon className="logout-icon side-icon" fill="#fff" />
            </div>
              Logout
         </div>
     </div>
     <LogoutModal  show={logOutModal}  onHide={() => setLogOutModal(false)}></LogoutModal>
   </div>
  )
}

export default Sidebar